
const isIOS = navigator => navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

export { 
    isIOS 
};